import PosterBase from './PosterBase';
import OfficialDesign from './designs/OfficialDesign';
import BurstDesign from './designs/BurstDesign';
import SidebarDesign from './designs/SidebarDesign';
import CalendarDesign from './designs/CalendarDesign';
import NeonDesign from './designs/NeonDesign';
import TimelineDesign from './designs/TimelineDesign';
import MagazineDesign from './designs/MagazineDesign';
import LandscapeSplitDesign from './designs/LandscapeSplitDesign';
import LandscapeBillboardDesign from './designs/LandscapeBillboardDesign';
import LandscapeCardsDesign from './designs/LandscapeCardsDesign';
import LandscapeOfficialDesign from './designs/LandscapeOfficialDesign';
import { TEMPLATES, THEME_GROUPS, getTheme, DEFAULT_TEMPLATE } from './themes';

export { TEMPLATES, THEME_GROUPS, DEFAULT_TEMPLATE };

// The poster DESIGNS (each its own layout — see designs/*). A theme without a `design` is the original layout (PosterBase) in a palette.
const DESIGNS = {
    official: OfficialDesign,
    burst: BurstDesign,
    sidebar: SidebarDesign,
    calendar: CalendarDesign,
    neon: NeonDesign,
    timeline: TimelineDesign,
    magazine: MagazineDesign,
    'l-split': LandscapeSplitDesign,
    'l-billboard': LandscapeBillboardDesign,
    'l-cards': LandscapeCardsDesign,
    'l-official': LandscapeOfficialDesign,
};

/**
 * BiggaponTemplate — render a job's poster using the chosen template `templateId`.
 * Falls back to the default template if the id is unknown. Used in the admin
 * picker (with this job's data), the listing, and the detail/download views.
 */
export default function BiggaponTemplate({ templateId, job, business, showFooter = true, className = '' }) {
    const theme = getTheme(templateId);
    const Design = theme.design ? DESIGNS[theme.design] : null;
    if (Design) return <Design job={job} business={business} theme={theme} showFooter={showFooter} className={className} />;
    return <PosterBase job={job} business={business} theme={theme} showFooter={showFooter} className={className} />;
}
